module.exports = __webpack_public_path__ + "img/Applestore.69aa17e6.png";